import React from 'react';
import './ProfessionalProfile.css';

function ProfessionalProfile() {
  const roles = [
    {
      period: '2022 — 2024',
      company: 'Present Technologies',
      title: 'Frontend Developer',
      summary:
        'Worked on frontend delivery for projects connected to Farfetch and associated stores, handling React development, CSS fixes, Jenkins pipeline issues and day-to-day Agile execution with the client.',
    },
    {
      period: '2020 — 2022',
      company: 'YCLIENT',
      title: 'Fullstack Developer',
      summary:
        'Built and maintained features for a client management platform using C#, .NET Core, Razor, MSSQL and APIs that supported a mobile application.',
    },
    {
      period: '2017 — 2019',
      company: 'FlipKick / Stredeo',
      title: 'Fullstack and Frontend Developer',
      summary:
        'Worked on media platforms, online video tools and indexing systems with React, ASP.NET, Azure Cognitive Services and database management.',
    },
  ];

  const stack = [
    'React',
    'JavaScript',
    'C#',
    '.NET Core',
    'ASP.NET',
    'Razor',
    'C++',
    'PHP',
    'Python',
    'MSSQL',
    'MySQL',
    'REST APIs',
    'Jenkins',
    'Azure',
    'Git',
    'Linux',
  ];

  return (
    <section className="portfolio-section professional-profile" id="professional-profile">
      <div className="section-heading">
        <span className="section-kicker">Professional</span>
        <h2 className="section-title">Professional profile.</h2>
        <p className="section-description">
          Frontend and fullstack experience focused on product delivery,
          maintenance and implementation in real business environments.
        </p>
      </div>

      <div className="professional-grid">
        <div className="professional-summary">
          <p>
            My background combines React and .NET product work with backend
            systems, databases and a broader interest in embedded technology and
            hardware prototyping.
          </p>
        </div>

        <div className="professional-experience">
          {roles.map((role) => (
            <article key={`${role.company}-${role.period}`} className="experience-item">
              <span className="experience-period">{role.period}</span>
              <h3>
                {role.title}
                <span>{role.company}</span>
              </h3>
              <p>{role.summary}</p>
            </article>
          ))}
        </div>
      </div>

      <div className="professional-stack">
        {stack.map((item) => (
          <span key={item} className="professional-stack-tag">
            {item}
          </span>
        ))}
      </div>
    </section>
  );
}

export default ProfessionalProfile;
